import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getCoverageCodesAndMergeCodes, replaceData } from '../../../../utilities/common';

import Label from '../../../Form/Label';
import Text from '../../../Global/Text';
import Coverage from '../Coverage';
import Space from '../Space';

class Basic extends Component {
  render() {
    const {
      heading,
      headingLink,
      bodyProps,
      dispatch,
      values,
      setValues,
      userData,
      initialValues,
    } = this.props;

    const that = this;

    if (!this.state.show) {
      setTimeout(() => { that.setState({ show: true }); }, 10);
    }

    const { coverageList, coverageMerge } = initialValues;

    const renderCoverages = coveragesOriginal => {
      const coverages = replaceData(coveragesOriginal, userData);
      const [coverageCodes, coverageCodesMerge] =
        getCoverageCodesAndMergeCodes(
          coverages && coverages.split('.').reduce((obj, index) => obj[index], userData),
          coverageMerge,
          userData
        );

      return (
        <div className="text__desc--name">
          {coverageCodesMerge && Object.keys(coverageCodesMerge)
            .map((key, index) =>
              <span>
                {index > 0 &&
                ', '
                }
                <Coverage variant='nameSimple' coverageCode={key} showDescription={false} />
              </span>
            )
          }
          {coverageCodes
            .filter(item => coverageList && coverageList[item] && !coverageList[item].icon)
            .map((listItem, index) =>
              <span>
                {(index > 0 || Object.keys(coverageCodesMerge).length > 0) &&
                ', '
                }
                <Coverage variant='nameSimple' coverageCode={listItem} showDescription={false} />
              </span>
            )
          }
          .
        </div>
      );
    };

    const productSelectorEdit = classNames(
      'grid__col grid__col--2', {
        'edit--text': headingLink.variant === 'editLink',
      }
    );
    return (
      <div className="product-selector__item product-selector__item--no-margin">
        <div className="product-selector__item__inner product-selector__item__inner-v2 v2 product-selector__item__inner--wide">
          <div className="product-selector--headline product-selector--headline-v2">
            <div className="headline-wrapper grid">
              <div className="grid__col grid__col--7">
                <Text component="span" className="headline-text" value={heading}/>
              </div>
              <div className={productSelectorEdit}>
                <Label
                  id="advancedProductFooterNote"
                  label={headingLink.label}
                  className="link"
                  actions={headingLink.actions}
                  dispatch={dispatch}
                  values={values}
                  setValues={setValues}
                />
              </div>
            </div>
          </div>
          <div className="grid">
            {bodyProps.map(prop =>
              <div className="grid__col grid__col--12 grid__col--md-6">
                <Text component="div" className="text__desc" value={prop.title}/>
                {prop.body &&
                  <Text component="div" className="text__desc--text" value={prop.body}/>
                }
                {prop.coverages &&
                  renderCoverages(prop.coverages)
                }
                <Space />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Basic;

Basic.defaultProps = {};

Basic.propTypes = {
  initialValues: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  headingLink: PropTypes.object.isRequired,
  bodyProps: PropTypes.array.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Steps/General/ProductSelector/Basic.jsx